import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS, text3XL } from '@styles/fonts'
import styled from 'styled-components'

export const AppraisalForm = styled.section`
  padding: 64px 0;
`

export const AppraisalFormTitle = styled.h2`
  ${text3XL};
  text-transform: unset;
  font-family: ${FONTS.medium};
  margin-bottom: 40px;
`

export const AppraisalFormDes = styled.p`
  color: ${COLORS.secondary};
`

export const AppraisalFormFooter = styled.div`
  color: ${COLORS.secondary};

  > div {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  button {
    white-space: nowrap;
  }
`
